import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
import { Link, useLocation, useNavigate } from "react-router-dom";

const MarqueeFun = () => {
  const { loading, total, settingInfo, faqsListing } = useSelector(
    ({ Settings }) => Settings
  );
  const mymarquee = useRef();
  const navigate = useNavigate();

  let lang = localStorage.getItem('lang')



  const handleSymbol = (e, item) => {
    e.preventDefault();
    navigate("/graph/" + item?.mainnet_symbol, {
      state: item
    })
  }

    /**
     * Used for render the UI on home page for marque line
     */
  return (
    <section className="marquess_Lsit">
      <Marquee
        direction={"left"}
        // direction={lang == "ar" ? "right" : "left"}

        pauseOnHover="true"
      >

        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">

          {settingInfo?.marqueeData?.length > 0 &&
            settingInfo?.marqueeData?.map((itm, idx) => (
              <li className="px-3" key={idx}>
                <Button
                  variant="transparent"
                  className="px-1 border-0 py-0 text-white"
                  onClick={(e) => handleSymbol(e, itm)}
                >
                  <div className="d-flex align-items-center CardCstm gap-2">
                    <p className="m-0">
                      <span className="icn d-inline-flex">
                        <span className="darkTheme me-2">
                          <img
                            alt={itm?.mainnet_symbol}
                            src={itm?.icon}
                            width={24}
                            height={24}
                          />
                        </span>
                      </span>
                      <span className="text-white">{itm?.mainnet_symbol}</span>
                    </p>
                    <p className="m-0 mx-1 text-white">{itm.usdValue} USD</p>

                    <p
                      className={`m-0 mx-1 ${itm.isInPlus ? "text-success" : "text-danger"
                        } `}
                    >
                      $ {Math.abs(itm.deferenceInPrice?.toFixed(2))}
                      {itm.isInPlus ? (
                        <span className="ms-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="8"
                            viewBox="0 0 9 8"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_2_2)">
                              <path
                                d="M8 7L4.5 4.16854L1 7"
                                stroke="#308B05"
                                stroke-width="1.25"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8 3.83142L4.5 0.99996L1 3.83142"
                                stroke="#308B05"
                                stroke-width="1.25"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2_2">
                                <rect
                                  width="9"
                                  height="8"
                                  fill="white"
                                  transform="matrix(-1 0 0 -1 9 8)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      ) : (
                        <span className="ms-1">
                          <svg
                            width="9"
                            height="8"
                            viewBox="0 0 9 8"
                            fill="none"
                            focusable="false"
                            className="chakra-icon css-5l21jh"
                          >
                            <path
                              d="M1 1L4.5 3.83146L8 1"
                              stroke="#FD3131"
                              strokeWidth="1.25"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M1 4.16858L4.5 7.00004L8 4.16858"
                              stroke="#FD3131"
                              strokeWidth="1.25"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                        </span>
                      )}
                    </p>
                  </div>
                </Button>
              </li>
            ))
          }
        </ul>
      </Marquee>
    </section>
  );
};

export default MarqueeFun;
